import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { ISetNameAction } from '../../../../ts/ServerApi/types/actionNames';
import { renameContent } from '../../../actions/spaces/RenameContentAction';
import { AppState } from '../../../state/AppState';
import { IEntityAction } from './IEntityAction';

export const RenameEntityAction: IEntityAction<IContentInfo, ISetNameAction> = {
  name: 'rename',
  translateName: Messages.rename_action,
  isVisible: () => true,
  isClickable: (availableActions: ISetNameAction, targetItems: IContentInfo[], state: AppState) =>
      targetItems.length === 1 && availableActions && availableActions.setName,
  createReduxAction: (targetItems: IContentInfo[]) => renameContent(targetItems[0])
};
